<div (click)="selectOption(1)">
  <div class="row flex-sm-nowrap m-2 py-3 px-1 cursor-pointer d-flex justify-content-left align-items-center"
    [ngClass]="selectedOption === 1 ? 'border-brand-thick' : 'border'">
    <div class="py-3 pl-3 pr-2">
      @if (selectedOption === 1) {
        <img class="pr-2" alt="" src="/assets/images/radio_chacked_icon.svg">
      } @else {
        <img class="pr-2" alt="" src="/assets/images/radio_empty_icon.svg">
      }
    </div>
    <div class="pr-1">
      <img alt="" src="/assets/images/fuse_from_top_icon.png" height="70">
    </div>
    <div class="px-4">
      <div class="font-size-m font-weight-semibold">
        <b>
          <ng-container i18n="@@app.feed-out_from_the_top">Feed-out from the top</ng-container>
        </b>
      </div>
    </div>
  </div>
</div>
<div (click)="selectOption(2)">
  <div class="row m-2 py-3 px-1 cursor-pointer d-flex justify-content-left align-items-center"
    [ngClass]=" selectedOption === 2 ? 'border-brand-thick' : 'border'">
    <div class="py-3 pl-3 pr-2">
      @if (selectedOption === 2) {
        <img class="pr-2"  alt="" src="/assets/images/radio_chacked_icon.svg">
      } @else {
        <img class="pr-2"  alt="" src="/assets/images/radio_empty_icon.svg">
      }
    </div>
    <div class="pr-1">
      <img alt="" src="/assets/images/fuse_from_bottom_icon.png" height="70">
    </div>
    <div class="px-4">
      <div class="font-size-m font-weight-semibold">
        <b>
          <ng-container i18n="@@app.feed-out_from_the_bottom">Feed-out from the bottom</ng-container>
        </b>
      </div>
    </div>
  </div>
</div>

